import { render, staticRenderFns } from "./PageLayout.vue?vue&type=template&id=53fcdc52&scoped=true"
import script from "./PageLayout.vue?vue&type=script&lang=js"
export * from "./PageLayout.vue?vue&type=script&lang=js"
import style0 from "./PageLayout.vue?vue&type=style&index=0&id=53fcdc52&prod&lang=css"
import style1 from "./PageLayout.vue?vue&type=style&index=1&id=53fcdc52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53fcdc52",
  null
  
)

export default component.exports